<template>
<div class="images-manager">
    <div class="image-controls">
        <!-- <div v-if="isGBItem && canEdit" :class="['button', 'action']" @click="$emit('reSyncProductImages')">Resync Images</div> -->
        <div :class="['button', canEdit ? 'action' : 'disabled']" @click="openImageModal()">Manage Images</div>
    </div>
    <div v-if="isGBItem && !canEdit" class="small span-two">Due to GunBroker API limitations, after listing, images can only be edited on the GunBroker site.</div>

    <div v-if="localImages.length > 0" class="images-list">
        <img v-for="(image, index) in localImages" :key="index" class="image-item" :src="image.image_src" @click="showLarge(image)" />
    </div>

    <div v-else class="images-list">
        <div class="image-item no-images">
            No images available
        </div>
    </div>

	<div v-if="showModal" class="modal">
        <div class="inner">
            <h2>Product Images</h2>
            <div class="content">
                <p class="bold">Add up to 10 images for this item. Drag images to display in the order you want. The Primary image will be the one that shows on list/catalog pages, and the first image to show on the product detail page.</p>
                <p>Image files should be <b>2MB or less</b> in size and a <b>standard image type</b> (jpg, png, gif, or webp).</p>
                <div id="upload-status" class="bold" style="margin-bottom: 1em;"></div>
                <draggable class="images-list" handle=".draggable" :sort="true" v-model="sortedImages" @end="endDrag">
                    <div v-for="(image, index) in sortedImages" :key="index" class="image-item draggable">
                        <img :src="image.image_src" :alt="image.name" @click="showLarge(image)" />
                        <div class="primary-label-wrapper">
                            <div v-if="index === 0" class="primary-label">Primary</div>
                            <div v-if="image.client_id != getClientId" class="primary-label">System</div>
                        </div>
                        <i v-if="image.client_id == getClientId" class="fa fa-trash" @click="handleClickRemove(image.product_image_id)"></i>
                    </div>
                    <vue-dropzone v-if="activeImages.length < 10" @vdropzone-success="uploadSuccess" ref="imageDropzone" id="image_dropzone" :options="dropzoneOptions" :useCustomSlot="true" class="image-item filler">
                        <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 462.54"><path fill-rule="nonzero" d="M49.68 0h337.29c13.65 0 26.06 5.64 35.03 14.61l.83.91c8.53 8.94 13.81 21.05 13.81 34.17V192.3c-13.83-3.96-28.43-6.1-43.53-6.1-7.25 0-14.38.5-21.37 1.45l38.17-35.52V49.69c0-5.95-2.36-11.49-6.2-15.62l-.6-.56c-4.16-4.16-9.89-6.79-16.14-6.79H49.68c-6.05 0-11.55 2.35-15.62 6.14l-.58.62c-4.16 4.16-6.76 9.91-6.76 16.21v177.93c29.58-26.67 76.93-63.95 106.82-89.08 4.88-4.22 12.14-4.13 16.93-.04.97.81 1.69 1.79 2.5 2.75l69.64 105.62 24.89-75.76c1.99-10.58 14.49-14.09 22.06-7.06l45.01 43.1c-7.78 4.48-15.12 9.62-21.99 15.32l-23.17-22.24-25.4 78.78c-1.6 11.15-15.44 15.38-22.92 6.78l-80.27-118.34-114.1 95.68v79.68c0 6.26 2.63 11.99 6.79 16.15 4.19 4.2 9.96 6.82 16.17 6.82h187.54c1.29 9.18 3.37 18.11 6.18 26.72H49.68c-13.58 0-26.04-5.62-35.07-14.64C5.64 368.88 0 356.46 0 342.81V49.69c0-13.67 5.59-26.11 14.58-35.11l.92-.83C24.45 5.25 36.49 0 49.68 0zm343.43 224.75c32.83 0 62.56 13.31 84.06 34.82 21.52 21.52 34.83 51.24 34.83 84.07 0 32.83-13.31 62.57-34.82 84.07-21.51 21.52-51.24 34.83-84.07 34.83-32.82 0-62.55-13.31-84.07-34.83-21.51-21.5-34.82-51.24-34.82-84.07 0-32.8 13.31-62.5 34.82-84.02 21.57-21.56 51.27-34.87 84.07-34.87zm-8.57 66.1h17.16c4.06 0 7.39 3.37 7.39 7.38v29.46h29.44c4.06 0 7.39 3.4 7.39 7.39v17.15c0 4.02-3.37 7.4-7.39 7.4h-29.44v29.44c0 4.02-3.37 7.39-7.39 7.39h-17.16c-4.02 0-7.39-3.32-7.39-7.39v-29.44h-29.47c-4.02 0-7.39-3.33-7.39-7.4v-17.15c0-4.07 3.32-7.39 7.39-7.39h29.47v-29.46c0-4.06 3.32-7.38 7.39-7.38zm76.4-15.05c-17.34-17.34-41.34-28.09-67.83-28.09-26.5 0-50.5 10.73-67.86 28.07-17.34 17.35-28.07 41.36-28.07 67.86 0 26.49 10.75 50.5 28.09 67.84 17.36 17.36 41.36 28.1 67.84 28.1 26.49 0 50.49-10.74 67.84-28.1 17.35-17.34 28.09-41.35 28.09-67.84 0-26.48-10.74-50.48-28.1-67.84zM267.9 61.14c11.04 0 21.06 4.48 28.31 11.73s11.73 17.26 11.73 28.31c0 11.03-4.48 21.06-11.73 28.31s-17.27 11.73-28.31 11.73c-11.05 0-21.06-4.48-28.31-11.73s-11.73-17.28-11.73-28.31c0-11.05 4.48-21.06 11.73-28.31s17.26-11.73 28.31-11.73zm12.22 27.82a17.281 17.281 0 0 0-12.22-5.05c-4.77 0-9.1 1.94-12.22 5.05a17.272 17.272 0 0 0-5.04 12.22c0 4.77 1.93 9.1 5.04 12.22 3.12 3.11 7.45 5.05 12.22 5.05 4.77 0 9.1-1.94 12.22-5.05 3.11-3.12 5.05-7.45 5.05-12.22 0-4.77-1.94-9.1-5.05-12.22z"/></svg>
                    </vue-dropzone>
                    <div v-else class="error">
                        Maximum of 10 images allowed. Please delete one before adding more.
                    </div>
                </draggable>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="cancel()">Done With Images</div>
                <!-- <div :class="['button', loading ? 'disabled' : 'action', 'spaced']" @click="save()">Save</div> -->
            </div>
        </div>
    </div>

	<div v-if="largeImage" class="modal">
        <div class="inner">
			<h2>Image Preview</h2>
            <div class="content">
                <img v-if="largeImage.image_src_large" :src="largeImage.image_src_large" class="large-image">
                <img v-else="largeImage.image_src" :src="largeImage.image_src" class="large-image">
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="largeImage = ''">Cancel</div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
export default {
    name: 'ImagesManager',
    components: {
        'vue-dropzone': vue2Dropzone,
    },
    props: {
        images: {
            type: Array,
            default: () => []
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        productId: {
            type: String,
            default: ''
        },
        isGBItem: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            localImages: [],
            showModal: false,
            largeImage: ''
        }
    },
    created() {
        this.localImages = JSON.parse(JSON.stringify(this.images));
    },
    watch: {
    },
    computed: {
        sortedImages: {
            get() {
                return this.localImages.filter(image => image.inactive !== 1)
                    .sort((a, b) => a.sort_order - b.sort_order);
            },
            set(newImages) {
                if (!Array.isArray(newImages)) {
                    return;
                }
                const sortOrder = newImages.filter(image => image.inactive !== 1)
                        .map((image, index) => ({ ...image, sort_order: index + 1 }));
                newImages.filter(image => image.inactive !== 1)
                    .forEach((image, index) => {
                        image.sort_order = sortOrder[index].sort_order;
                    });
                
                this.localImages = newImages;
            }
        },
        activeImages() {
            return this.localImages.filter(img => img.inactive !== 1);
        },
        dropzoneOptions() {
			return {
				url: this.getApiEndpoint + '?action=upload_product_image',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 2.0,
				addRemoveLinks: true,
				thumbnailMethod: 'contain',
				dictDefaultMessage: 'Drop an image file here, or click to find an image...',
                acceptedFiles: "image/jpeg,image/png,image/gif,image/webp",
                init: function() {
                    this.on("uploadprogress", function(file) {
                        // on-screen message besides progress bar:
                        document.getElementById('upload-status').innerHTML = "<p>Uploading and processing file...</p><div class='modal-icon'><i class='fa fa-spinner fa-spin'></i></div>";
                    })
                },
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'INVENTORY',
					context: 'PRODUCT',
					product_id: this.productId,
				}
			}
		}
    },
    methods: {
        openImageModal() {
            this.localImages = [...this.sortedImages]; // always pull a fresh copy of images in the right order
            if (this.canEdit) {
                this.showModal = true;
            }
        },
		endDrag(event) {
			// this.sortedImages = event
            this.updateProductImages('sort');
		},
        handleClickRemove(productImageId) {
            const images = JSON.parse(JSON.stringify(this.localImages));
            const index = this.localImages.findIndex(image => image.product_image_id === productImageId)
            //if (this.isGBItem) {
            //    images.splice(index, 1);
            //} else {
                images[index].inactive = 1;
                images[index].sort_order = 0;
            //}
            this.sortedImages = images
            this.updateProductImages('delete');
        },
        async uploadSuccess(file, response) {
			response = JSON.parse(response)
            const uploadStatus = document.getElementById('upload-status');
            if (response.status === 'success') {
                const newImage = {
                    product_image_id: '',
                    client_id: response.client_id,
                    image_id: response.image_id,
                    image_src: response.image_src,
                    image_src_large: response.image_src_large,
                    sort_order: this.localImages.length + 1,
                    product_id: this.productId,
                    inactive: 0
                };
                this.$set(this, 'localImages', [...this.localImages, newImage]);
                this.$refs['imageDropzone'].removeAllFiles();
                this.$forceUpdate();
                // if (!this.isGBItem) {
                    await this.updateProductImages('upload');
                // } else {
                //     if (uploadStatus) uploadStatus.innerText = "";
                // }
            } else {
                this.$refs['imageDropzone'].removeAllFiles();
                if (uploadStatus) uploadStatus.innerHTML = "<p>Oops! " + response.message + "</p>";
                this.$emit('error', 'Image upload failed');
            }
        },
        async updateProductImages(context = '') {
            // console.log('Updating product images', this.localImages);
            if (this.loading) return;
            this.loading = true;
            const uploadStatus = document.getElementById('upload-status');
            if (uploadStatus) uploadStatus.innerHTML = "<p>Saving image" + (context === 'sort' ? ' sort order' : 's') + "...</p><div class='modal-icon'><i class='fa fa-spinner fa-spin'></i></div>";
            // Wait until everything has updated before making the API call otherwise
            // this.localImages may not be what you think it should be.
            await this.$nextTick(async () => {
                await this.apiCall({ destination: 'update_product_images', data: { product_id: this.productId, product_images: this.localImages } })
                .then(obj => {
                    if (obj.status == 'success') {
                        this.localImages = obj.product_images;
                        if (uploadStatus) uploadStatus.innerText = "";
                        //if (this.isGBItem) {
                            this.$emit('updateImages', this.localImages);
                        //}
                    }
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err)
                    this.loading = false
                })
            });
		},
        showLarge(image) {
            if (image.image_id && image.image_src) {
                this.largeImage = image;
            }
        },
        async save() {
            // If this is a GunBroker item, we don't update images here, just emit the change.
            // The parent component will handle syncing images to GunBroker and also saving them to
            // product_client_data.
            if (!this.isGBItem) {
                await this.updateProductImages('save');
            }
            this.$emit('updateImages', this.localImages);
            this.showModal = false;
        },
        cancel() {
            // this.localImages = [...this.images]; // Reset local images to original state
            this.showModal = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.images-manager {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1.8em;
}
.image-controls {
    display: flex;
    justify-content: flex-end;
    gap: 0.5em;
    width: 100%;
    .button { width: 100%; }
}
.images-list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 0.5em;
    width: 100%;
    .no-images {
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    img {
        display: block;
        border-radius: 6px;
        object-fit: contain;
        max-height: 200px;
        max-width: 100%;
    }
    @media (max-width: 1100px) {
        flex-direction: row;
        justify-content: center;
        gap: 0.5em 2em;
        img { 
            width: auto !important;
            flex-basis: 45%;
        }
    }
}
.modal {
    .inner {
        width: 90vw;
        min-width: 80vw;
        max-width: calc(100vw - 10em);
        max-height: none;
        overflow-y: auto;
    }

    .content {
        position: relative;
        height: 70vh !important;
        max-height: none;
    }

    .images-list {
        display: flex;
        flex-direction: row;
        gap: 1em;
        margin-top: 2em;

        #image_dropzone {
            overflow: hidden;
            padding: 10px;
        }

        .image-item {
            border: 1px solid #ccc;
            border-radius: 6px;
            flex: 18%;
            max-width: 18%;
            height: 200px !important;
            position: relative;
            overflow: unset;
            cursor: grab;
            transition: transform 0.3s ease;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                display: block;
                border-radius: 6px;
                object-fit: contain;
                max-height: 198px;
                max-width: 100%;
            }

            .primary-label-wrapper {
                position: absolute;
                top: -5px;
                left: -5px;
            }
            .primary-label {
                display: inline-block;
                background-color: gray;
                color: #fff;
                margin: 0 2px 0 0;
                padding: 3px 6px;
                border-radius: 4px;
                font-size: 0.8em;
                font-weight: bold;
                text-transform: uppercase;
            }

            i {
                position: absolute;
                top: 5px;
                right: 5px;
                color: #fff;
                background-color: rgba(58, 58, 58, 0.9);
                padding: 5px;
                border-radius: 10%;
                cursor: pointer;
                // display: none;
            }
        }
        .image-item:hover {
            transform: scale(1.05);

        }
        .error {
            margin: 0 auto;
        }
 
    }
    img.large-image {
        position: absolute;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        top: 0; bottom: 0; left: 0; right: 0;
    }

}

#upload-status {
    position: absolute;
    width: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px dashed gray;
    border-radius: 1em;
    background:rgba(255, 255, 255, 0.9);
    padding: 4em 2em;
    text-align: center;
    z-index: 1000;
}
#upload-status:empty {
    display: none;
}

</style>

<style lang="scss">
.images-manager {
    .dropzone {
        padding: 0;
        cursor: pointer;

        &.dz-started {
            .dz-message, svg {
                display: none;
            }
        }

        .dz-preview {
            margin: 0;
            display: flex;
            align-items: stretch;
            justify-content: stretch;
        }

        .dz-message {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 !important;
            margin: 0 !important;
            height: 100%;
            width: 100%;

            svg {
                width: 90%;
                height: 80%;
                fill: #ccc;
            }
        }
    }
}
</style>